<template>
<div class="home">
	<b-jumbotron header="逐浪RPA频道-面向企业级的办公应用" lead="依托Zoomla!逐浪CMS企业级生产服务中国企业信息化">
	 <p>基于卓越的生产力软件</p>
	 <b-button variant="outline-primary" href="#">精彩呈现</b-button>
	</b-jumbotron>
	
<!-- 一个经典的响应式模板	
<b-container>
	<b-row>
		<b-col md="8" class="bg-info offset-md-2">aaa</b-col>		
	</b-row>		
</b-container> -->


<b-container class="home_list">
<b-row>	
	<b-col md="8" class="offset-md-2 mt-5" v-for="item in list" :key="item.GeneralID">
	<b-row>
	<b-col cols="12"><strong><a :href="'#/Item/'+item.GeneralID" class="">{{item.Title}}</a></strong></b-col>
	<b-col cols="12">
		<span class="name">{{item.Inputer}}</span> 
		<span class="date">{{item.CreateTime.split('T')[0]}}</span>
	</b-col>
	<b-col md="2">
	<a :href="'#/Item/'+item.GeneralID"><b-img-lazy :src="item.TopImg"></b-img-lazy></a>
	</b-col>
	<b-col md="10"  v-html = "item.content">
	</b-col>
	</b-row>
	</b-col>
	<div class="home_pagination">
	<b-pagination limit="9" align="center" v-model="page.cpage" @change="loadList()" :total-rows="page.itemCount" :per-page="page.psize" aria-controls="my-table" size="lg"></b-pagination></div>
</b-row>	
</b-container>



</div>
</template>
<script>
export default{
	data(){
		var ref=this;
		var model={list:[],page:{cpage:1,psize:5,itemCount:0}};
		var pnid=this.$route.params.pnid;
		// if(!pnid){pnid=30;}
		return model;
	},
	methods:{
			loadList:function(){
			var ref=this;
			setTimeout(function(){
				ref.jsp("content_list&pnid=168",ref.page).then((ret)=>{
					ref.list=JSON.parse(ret.result);
					ref.page=ret.page;
					for(let i=0;i<ref.list.length;i++){
						ref.list[i].content=ref.util.str.htmlToText(ref.list[i].content,150);
					}
					window.console.log(ret.page);
				});
			},50);//setTimeout end;
		}
	},
	mounted:function(){
		this.loadList();
	},
	// created(){
	// 	let animation=document.getElementById('animation')
	// 	if (animation != null){document.body.removeChild(animation)}
	// 	}
   created(){
            setTimeout(function () {
                let animation = document.getElementById('animation')
                if (animation != null) { document.body.removeChild(animation); }
            }, 5 * 1000);
        }	
}
</script>
<style lang="scss">
</style>